import React from "react";
import {connect} from "react-redux";
import {openModal} from "../../../actions/modal";
class Person extends React.Component {


    render() {
        const { openModal} = this.props;
        return (
          <div className={'col-12 col-md-4 rob-person__col'}>
          <div className=" rob-person">
              <div className={this.props.image === '' ? '': 'rob-person__img'} style={{ backgroundImage: `url(${this.props.image})`}}></div>
              <div className="rob-person__content">
                  <h1>{this.props.name}</h1>
                  <p>{this.props.position}</p>
                  <p>{this.props.phone}</p>
                  <a href={`mailto: ${this.props.email}`}>{this.props.email}</a>
              </div>
              {this.props.description ? (

                   this.props.description.length < 20 ? (
                    <div dangerouslySetInnerHTML={{__html: this.props.description}}>

                    </div>
                  ) : (
                    <div onClick={() => openModal('profile', this.props)} className="rob-person__button">
                        Read Bio
                    </div>
                  )
                ): (
                <div></div>
              )}

          </div>
          </div>


        )
    }

}

function mapStateToProps(state) {
    return {
        modal : state.modal
    };
}

export default connect(mapStateToProps, {openModal})(Person);




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/Person.js